import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=d4caa8ce&scoped=true&"
import script from "./Card.vue?vue&type=script&setup=true&lang=js&"
export * from "./Card.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Card.vue?vue&type=style&index=0&id=d4caa8ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4caa8ce",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QImg,QIcon,QExpansionItem,QItem});
